import { render, staticRenderFns } from "./SubjectImport.vue?vue&type=template&id=3491b4b2"
import script from "@/controllers/custom/subject/subject-import.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/subject/subject-import.js?vue&type=script&lang=js&external"
import style0 from "./SubjectImport.vue?vue&type=style&index=0&id=3491b4b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports